import styled from 'styled-components';

// Container principal para o título e as imagens
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  background: var(--black-color);
`;

// Título responsivo e centralizado
export const CommomTitle = styled.div.attrs({  
})`          
    font-size: 3vw;
    font-weight: bold;
    line-height: 3em;
    text-align: center;
    color: var(--white-color);
    margin: 0;
    
    width: 100%;
    max-width: 560px;

    // Ajuste para dispositivos móveis (abaixo de 768px)
  @media (max-width: 768px) {
    font-size: 6vw;
    max-width: 360px;
  }

  // Ajuste para telas muito grandes
  @media (min-width: 1200px) {
    font-size: 1.5rem;
  }

`; 

// Container dos cards — 3 lado a lado no desktop, empilhados no mobile
export const ImagesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 24px;
  max-width: 1100px;
  margin: 40px 0;
  padding: 0 20px;
  flex-wrap: wrap;

  @media (min-width: 900px) {
    flex-wrap: nowrap;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    margin: 20px 0;
    align-items: center;
  }
`;

// Imagem responsiva
export const Image = styled.img`
  width: 200px;
  height: auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const BannerCenterActions = styled.div.attrs({ 
})`            
    margin: 10px auto 10px;
    flex:1;
    width: 210px;
`; 

export const BannerTitle = styled.h1.attrs({ 
})`       
    font-size: 18px;
    color: var(--darkprimary-color);    

    text-align: center;

`;

export const ColorLink = styled.div.attrs({ 
})`           
    color: var(--white-color);
    text-decoration: underline;
    outline: 1px solid var(--black-color);
    border-radius: 4px;  
`;

// Estilo do card com design profissional
export const Card = styled.div`
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  max-width: 380px;
  min-height: 450px;
  padding: 30px;
  text-align: center;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 769px) {
    flex: 1;
    max-width: 450px;
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  &:nth-child(2) {
    border: 2px solid var(--primary-color);
    &::before {
      content: "MAIS POPULAR";
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
      background: var(--primary-color);
      color: white;
      padding: 5px 20px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  @media (max-width: 768px) {
    max-width: 100%;
    min-height: 400px;
    padding: 25px;
  }
`;

// Imagem circular no topo do quadrado
export const CircleImageContainer = styled.div`
  width: 100%;
  height: auto;
  border-radius: 5%;
  overflow: hidden;
  margin: auto;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 5%;
  }
`;

// Título do plano
export const CardText = styled.div`          
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 1.2;
    text-align: center;
    color: #2c3e50;
    margin: 0 0 15px 0;
    
    @media (max-width: 768px) {
      font-size: 1.3rem;
      margin: 0 0 10px 0;
      line-height: 1.1;
    }
`;

// Container para preço
export const PriceContainer = styled.div`
  margin: 15px 0;
  text-align: center;
  line-height: 1.1;
`;

// Preço principal
export const Price = styled.div`
  font-size: 2.5rem;
  font-weight: 900;
  color: var(--primary-color);
  line-height: 1;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// Preço original riscado
export const OriginalPrice = styled.span`
  font-size: 1.2rem;
  color: #999;
  text-decoration: line-through;
  margin-right: 10px;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

// Badge de desconto
export const DiscountBadge = styled.div`
  background: linear-gradient(45deg, #ff6b6b, #ff8e8e);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: bold;
  margin: 10px auto;
  display: inline-block;
  box-shadow: 0 2px 10px rgba(255, 107, 107, 0.3);
`; 

export const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 15px 0;
  text-align: left;
  flex: 1;

  li {
    font-size: 1rem;
    color: #555;
    margin-bottom: 8px;
    padding: 6px 0;
    padding-left: 25px;
    position: relative;
    border-bottom: 1px solid #f0f0f0;
    line-height: 1.3;

    &:before {
      content: "✓";
      position: absolute;
      left: 0;
      top: 6px;
      color: #4CAF50;
      font-weight: bold;
      font-size: 1.1rem;
      
      @media (max-width: 768px) {
        top: 4px;
        font-size: 1rem;
      }
    }

    &:last-child {
      border-bottom: none;
    }

    @media (max-width: 768px) {
      font-size: 0.9rem;
      margin-bottom: 6px;
      padding: 4px 0;
      padding-left: 25px;
      line-height: 1.2;
    }
  }
`;

// Botão de ação do card
export const CardButton = styled.div`
  margin-top: 20px;
  
  button {
    width: 100%;
    padding: 15px;
    font-size: 1.1rem;
    font-weight: bold;
    border-radius: 30px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }
  }
`;